export { default } from './QuickClickCard';